import { reduce } from '@atlaskit/adf-utils/traverse';
import type { ADFEntity } from '@atlaskit/adf-utils/types';

import { wordCount } from './wordCount';

/**
 * Counts words across all text nodes in an ADF fragment.
 */
export const countFragmentWords = (fragmentNodes: ADFEntity[]): number =>
	fragmentNodes.reduce(
		(total, node) =>
			reduce<number>(
				node,
				(count, n: ADFEntity) => (n.type === 'text' ? count + wordCount(n.text) : count),
				total,
			),
		0,
	);
